module.exports = "/assets/dist/images/bodystyles_suvs.png?8a2b0cb900f1c299eaf3993cb906e795";